import React from "react";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

import { useHelp } from "./useHelp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { helpColor, iconSize } from "../../App/GridRenderers";


const HelpIcon = ({ mt = 0, show = true }) => {
    const { toggleHelp } = useHelp();
    return (
        <div>
            {show && (
                <Stack sx={{ pt: 2, mt: mt }}>
                    <Tooltip title="Help"
                        enterDelay={1000}>

                        <FontAwesomeIcon
                            icon={faQuestionCircle}
                            color={helpColor}
                            size={iconSize}
                            onClick={() => {
                                toggleHelp()
                            }}
                        />
                    </Tooltip>

                </Stack>
            )}
        </div >

    );
};

export default HelpIcon;